import { useParams } from 'react-router-dom'
import { buildErrorMessage } from '@constants'
import { AxiosError } from 'axios'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { getPdfPlanSettings } from '@queries'
import { postPdfPlanSettings } from '@mutations'

const usePostPlanSettings = () => {
  const { projectId } = useParams()
  const { enqueueSnackbar } = useSnackbar()

  const queryClient = useQueryClient()

  const {
    mutateAsync: postPlanSettings,
    isLoading: isPostingPlanSettings,
    error: postPlanSettingsError,
  } = useMutation(
    (planSettings: PdfPlanSettings) => {
      const queryKey = getPdfPlanSettings.getKey(projectId as string)
      const currentSettings = queryClient.getQueryData<PdfPlanSettings>(queryKey)
      return postPdfPlanSettings.request(projectId as string, {
        ...currentSettings,
        ...planSettings,
      })
    },
    {
      onSuccess: (data: PdfPlanSettings) => {
        const queryKey = getPdfPlanSettings.getKey(projectId as string)
        queryClient.setQueryData<PdfPlanSettings>(queryKey, data)
      },
      onError: (error: AxiosError) => {
        enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Speichern der Plansettings'), {
          variant: 'error',
        })
      },
    },
  )

  return {
    mutateAsync: postPlanSettings,
    isLoading: isPostingPlanSettings,
    error: postPlanSettingsError,
  }
}

export default usePostPlanSettings
